import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    LandingPageStubFragment,
    GetLandingPages as GetLandingPagesQuery,
} from 'nutshell-graphql-types';

import GET_LANDING_PAGES from '../queries/get-landing-pages.graphql';

export function useGetLandingPages(showArchived?: boolean): {
    landingPages: LandingPageStubFragment[];
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetLandingPagesQuery, Record<any, any>>(
        GET_LANDING_PAGES,
        {
            fetchPolicy: 'cache-and-network',
            variables: {
                archived: showArchived,
            },
        }
    );

    return {
        landingPages: data && data.pages ? data.pages : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
